import React, { useEffect, useState } from "react";
import { GoCheckCircleFill } from "react-icons/go";

const SuccessPage = ({ redirectURL, formData}) => {
  const [timer, setTimer] = useState(5);

  useEffect(() => {
    let interval = setTimeout(() => {
      if (timer > 0) {
        setTimer((timer) => timer - 1);
      } else {
        if (redirectURL) {
          window.location = `${redirectURL}`;
        } else {
          window.location.reload(true);
        }
      }
    }, 1000);

    return () => clearTimeout(interval);
  }, [timer, redirectURL]);

  return (
    <div
      className="bg-[#e9ecef] flex items-center justify-center min-h-screen"
      style={{
        backgroundColor: "#fff",
        backgroundImage:
          "radial-gradient(rgba(183, 228, 199,1) 10%, transparent 10%)",
        backgroundPosition: "0% 0%",
        backgroundSize: "1rem 1rem"
      }}
    >
      <div className="bg-white rounded-lg drop-shadow-2xl px-8 py-10 w-full max-w-[1000px]">
        {/* Icon and Heading */}
        <div className="flex flex-col items-center mb-6 text-center">
          <GoCheckCircleFill className="md:text-[160px] text-[120px] text-[#52b69a]" />
          <p className="text-2xl font-bold md:text-[30px]">
            Your Initial Application Has Been Submitted,
          </p>
        </div>

        {/* Left-aligned details */}
        <div className="flex flex-col gap-4 text-left">
          <p>
            Selected applicants will be contacted only to continue on their application form and
            complete the needed fees payment.
          </p>

          <p>
            <strong>Please Note:</strong> No application is considered a formal application without
            payment of application and admission tests/placement test fees. Payment of application
            fees and admission tests/placement test fees does not mean admission or acceptance into
            the University.
          </p>

          <span
            className="font-semibold text-[#52b69a] md:text-lg"
            style={{ fontVariantNumeric: "tabular-nums" }}
          >
            Redirecting to home in <span>{timer}</span> seconds
          </span>

          <p className="text-center rtl text-base leading-relaxed">
            انا____ {formData.arabicFirstName?.value}____ بطاقة المدنية رقم___{formData.civilId?.value}___اقر و اوافق على جميع الشروط والاحكام المذكورة اعلاه

          </p>

        </div>
      </div>
    </div>

  );
};

export default SuccessPage;


